import { GisCoordinateResponse } from "../../api-models/response/GisCoordinateResponse";

export class CoordinateSystem {
  id: number;
  name: string;
  wkid: string;
  description?: Description;

  constructor(response: GisCoordinateResponse) {
    this.id = response.id;
    this.name = response.name;
    this.wkid = response.wkid;
    this.description = {
      areaOfUse: response.areaOfUse,
      minimumLatitude: response.minLatitude,
      minimumLongitude: response.minLongitude,
      maximumLatitude: response.maxLatitude,
      maximumLongitude: response.maxLongitude,
    };
  }
}

export const emptyCoordinateSystem: CoordinateSystem = {
  id: -1,
  name: "",
  wkid: "",
  description: undefined,
};

export interface Description {
  areaOfUse: string;
  minimumLatitude: string;
  minimumLongitude: string;
  maximumLatitude: string;
  maximumLongitude: string;
}
